import React, { useState } from "react"
import RichContent from "./RichContent"
import type { ReferenceTextPayload } from "../types"

// Texto/figura de referência que várias questões do mesmo bloco compartilham
// (interpretação de Português e Inglês, diagrama que serve a um grupo).
//
// Fica EXPANDIDO por padrão, ao contrário do "Texto associado" do QConcursos:
// lá a pessoa navega questões avulsas, aqui ela está fazendo prova e precisa do
// texto pra responder — esconder por padrão cobraria um clique em toda questão
// de interpretação. O botão de recolher existe pra quem já leu e quer só voltar
// às alternativas, que é o caso comum da 2ª questão em diante do mesmo texto.

interface ReferenceTextProps {
  reference: ReferenceTextPayload
}

export default function ReferenceText({ reference }: ReferenceTextProps) {
  const [open, setOpen] = useState(true)

  return (
    <section
      className="mt-4 rounded-xl border border-slate-200 bg-slate-50/70"
      aria-label="Texto de referência"
    >
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left cursor-pointer"
      >
        <span className="flex min-w-0 flex-col">
          <span className="text-xs font-semibold uppercase tracking-wide text-navy-500">
            Texto de referência
          </span>
          {reference.title && (
            <span className="truncate text-sm font-semibold text-navy-900">{reference.title}</span>
          )}
        </span>
        <span className="shrink-0 text-sm font-semibold text-navy-600">
          {open ? "Recolher" : "Ler texto"}
        </span>
      </button>

      {/* Menor que o enunciado de propósito: o texto é apoio, a pergunta é o que
          a pessoa responde. E com altura máxima — sem isso um texto de 2 mil
          caracteres empurra as alternativas duas telas abaixo no celular. */}
      {open && (
        <div className="max-h-[55vh] overflow-y-auto border-t border-slate-200 px-4 py-4 text-[0.9375rem] leading-relaxed text-navy-700">
          <RichContent html={reference.body} />
        </div>
      )}
    </section>
  )
}
